import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// Services
import { NetworkService } from '../../services/network/network.service';
import { WsErrorService } from '../../services/ws-error/ws-error.service';

export const ConnectionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const network = inject(NetworkService);
  const wsError = inject(WsErrorService);

  return new Observable((observer) => {
    wsError.removeWebServiceError();
    network.appStarted();

    observer.next(true);
  });
};
